import _ from 'lodash';

export const appointmentStatus = (appointments, requestedValue) => {
  const { horasEmProjeto, totalHorasPonto } = appointments;
  const groupById = _.groupBy(horasEmProjeto, 'id_aprovacao');

  const allStatus = Object.keys(groupById);
  const appointedHours = _.sumBy(horasEmProjeto, 'horas_apontadas');
  const currentObject = {};

  switch (true) {
    case !allStatus.length:
      currentObject.text = 'Não apontado';
      currentObject.status = 'not-pointed';
      break;
    case allStatus.includes('1'):
      currentObject.text = 'Em aprovação';
      currentObject.status = 'pending';
      break;
    case allStatus.includes('2') && totalHorasPonto - appointedHours !== 0:
      currentObject.text = 'Incompleto';
      currentObject.status = 'incomplete';
      break;
    case allStatus.includes('3'):
      currentObject.text = 'Reprovado';
      currentObject.status = 'refused';
      break;
    case allStatus.includes('2') && totalHorasPonto - appointedHours === 0:
      currentObject.text = 'Aprovado';
      currentObject.status = 'approved';
      break;
    default:
      currentObject.text = 'Recusado';
      currentObject.status = 'not-pointed';
  }

  return currentObject[requestedValue];
};
